/* istanbul ignore file */
import React from 'react';
import { Badge } from 'framework/ui/mui-builder';
import { FieldBadgeProps } from 'framework/ui/ui-builder';

const InternBadge = (props: FieldBadgeProps) => {
  return (
    <Badge color="primary" {...props}>
      Intern
    </Badge>
  );
};

export default InternBadge;
